export default __webpack_public_path__ + "static/media/card4.ed642323.png";